var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view'),_c('Alert'),_c('ConfirmDialog'),(_vm.hasActiveJobs && _vm.isAuthorized)?_c('JobsDialog'):_vm._e(),(_vm.isAppLoading)?_c('SpinnerLoader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }